const types = {
  connection: 'Connection',
  origo: 'Origo',
  glassStart: 'GlassConnectionStart',
  glassEnd: 'GlassConnectionEnd',
  openingConnection: 'OpeningConnectionStart',
  endingConnection: 'OpeningConnectionEnd',
  wall: 'WallLine',
};

export default types;
